@import '~less/global-variables';

/**
 * View offer
 */
.offer-view {
  .panel-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .panel-heading > .dropdown .dropdown-toggle {
    color: #fff;
  }
  .leaflet-marker-icon {
    outline: none;
  }

  .offer-location-section {
    border-top: 1px solid @gray-lighter;
    border-radius: 0 0 3px 3px;
    overflow: hidden;
  }

  .offer-location-heading {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 15px;
    color: @gray;
    font-size: @font-size-small;
    background: @gray-lighter;
  }
}

.offer-location {
  width: 100%;
  height: 300px;
}

.offer-restrictions {
  border-top: 1px solid @gray-lighter;
  padding-top: 10px;
  margin-top: 10px;
}

// TODO - check places where it is used
.dropdown-menu-offers {
  .offer-hosting-yes a:hover {
    background: @offer-hosting-yes;
    color: #fff;
  }
  .offer-hosting-maybe a:hover {
    background: @offer-hosting-maybe;
    color: #fff;
  }
  .offer-hosting-no a:hover {
    background: @offer-hosting-no;
    color: #fff;
  }
  .offer-meet a:hover {
    background: @offer-meet;
    color: #fff;
  }
}
